import React, {
  FC,
  MutableRefObject,
  useCallback,
  useEffect,
  useState,
} from "react";

import { ElementObserver } from "../ElementObserver";
import { isMobileMedia } from "../../../utils/media";
import { getBySelectorRegExp } from "../../../utils/dom";

type Props = {
  footer?: MutableRefObject<HTMLElement | null>;
  hideOnCreate?: boolean;
};

export const VideoAskObserver: FC<Props> = ({
  footer,
  hideOnCreate = false,
}) => {
  const [bottom, setBottom] = useState(20);

  // Handle footer resize
  useEffect(() => {
    if (!isMobileMedia() || !footer || !footer.current) return;

    const handleResize = () => {
      if (footer.current) {
        setBottom(footer.current.offsetHeight);
      }
    };

    const resizeObserver = new ResizeObserver(handleResize);
    resizeObserver.observe(footer.current);

    handleResize();

    return () => {
      resizeObserver.disconnect();
    };
  }, [footer, footer?.current?.offsetHeight]);

  // Set position for Intercom launcher on mobile
  const el = getBySelectorRegExp('button[class^="videoask-embed__button--"]');

  const setPosition = useCallback(
    (_el: HTMLElement) => {
      if (_el) {
        _el.style.position = "fixed";
        _el.style.bottom = `${bottom}px`;

        if (hideOnCreate) {
          _el.style.display = "none";
        } else {
          _el.style.display = "flex";
        }
      }
    },
    [bottom, hideOnCreate]
  );

  useEffect(() => {
    if (el && isMobileMedia()) {
      setPosition(el);
    }
  }, [el, setPosition]);

  return (
    <ElementObserver
      targetSelector='button[class^="videoask-embed__button--"]'
      callback={setPosition}
      disabled={!isMobileMedia()}
      useRegExpToSelect
    />
  );
};
